exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".headerrow[data-v-0766a008]{background:#eee;font-weight:600;margin-bottom:20px;margin-left:-20px;margin-right:-20px;padding:5px}", ""]);

// exports
